<template>
    <div>
        <ve-table rowKeyFieldName="rowKey" :fixed-header="true" :columns="computedHeaders" :table-data="data"
            :edit-option="editOption" :rowStyleOption="rowStyleOption"
            :column-width-resize-option="columnWidthResizeOption" border-y :cell-style-option="cellStyleOption"
            :max-height="height" style="word-break:break-word"/>
    </div>
</template>

<script>
import { h } from 'vue';
export default {
    name: "DealTable",
    props: ["headers", "data", "height", "type", "showActionAcc", "userPermission", "efficFunc", "respList"],
    data() {
        return {
            rowToDelete: null,
            dataSaved: [...this.data],
            columnWidthResizeOption: {
                enable: true,
                minWidth: 50 
            },
            rowStyleOption: {
                clickHighlight: false,
                hoverHighlight: false,
            },
            editOption: {
                beforeCellValueChange: () => { },
                afterCellValueChange: () => { },
            },
            cellStyleOption: {
                headerCellClass: ({ rowIndex }) => {
                    if (rowIndex == 0) {
                        return "deal-header-table";
                    }
                },

                bodyCellClass({ column }) {
                    if (column.field == "actionDelete") {
                        return "deal-header-table-delete-class";
                    }
                }
            },
        };
    },
    watch: {
        data: {
            handler(newValue) {
                this.dataSaved = [...newValue];
            },
            deep: true,
            immediate: true,
        },
    },
    computed: {
        computedHeaders() {
            return this.headers.map((col) => {
                if (["whenInitPrev", "whenFinishPrev", "whenInitReal", "whenFinishReal"].includes(col.field)) {
                    return {
                        ...col,
                        renderBodyCell: ({ row }) => {
                            return (
                                <input
                                    size="small"
                                    value={row[col.field]}
                                    on-input={(val) => {
                                        row[col.field] = val.target.value;
                                    }}
                                    title={row[col.field]}
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    style="padding: 0; border: none; text-align: center; background: none; max-width:6rem"
                                ></input>
                            );
                        }
                    };
                }

                if (col.field === "actionType") {
                    return {
                        ...col,
                        renderBodyCell: ({ row }) => {
                            return (
                                <select
                                    size="large"
                                    value={row[col.field]}
                                    title={row[col.field]}
                                    on-input={(val) => {
                                        row[col.field] = val.target.value;
                                    }}
                                    style="width: 100%; height: 100%; padding: 0; border: none; text-align: left; background: none;"
                                >
                                    <option label="Obrigatório" value="obrigatorio"></option>
                                    <option label="Opcional" value="opcional"></option>
                                </select>
                            )
                        }
                    };
                }

                if (col.field === "sixm") {
                    return {
                        ...col,
                        renderBodyCell: ({ row }) => {
                            return (
                                <select
                                    size="large"
                                    value={row[col.field]}
                                    title={row[col.field]}
                                    on-input={(val) => {
                                        row[col.field] = val.target.value;
                                    }}
                                    style="width: 100%; height: 100%; padding: 0; border: none; text-align: left; background: none;"
                                >
                                    <option label="Método" value="metodo"></option>
                                    <option label="Máquina" value="maquina"></option>
                                    <option label="Medida" value="medida"></option>
                                    <option label="Meio Ambiente" value="meioambiente"></option>
                                    <option label="Mão de Obra" value="maodeobra"></option>
                                    <option label="Matéria Prima" value="materiaprima"></option>
                                </select>
                            )
                        }
                    };
                }

                if (col.field === "who") {
                    return {
                        ...col,
                        renderBodyCell: ({ row }) => {
                            return (
                                <select
                                    size="large"
                                    value={row[col.field]}
                                    title={row[col.field]}
                                    on-input={(val) => {
                                        row[col.field] = val.target.value;
                                    }}
                                    style="width: 100%; height: 100%; padding: 0; border: none; text-align: left; background: none;"
                                >
                                    {this.respList.map(i => h('option', { value: i.id }, i.name))}
                                </select>
                            );
                        }
                    };
                }

                if (col.field === "actionStatus") {
                    return {
                        ...col,
                        renderBodyCell: ({ row }) => {
                            return (
                                <select
                                    size="large"
                                    value={row[col.field]}
                                    title={row[col.field]}
                                    on-input={(val) => {
                                        row[col.field] = val.target.value;
                                    }}
                                    style="width: 100%; height: 100%; padding: 0; border: none; text-align: left; background: none;"
                                >
                                    <option label="Pendente" value="pending"></option>
                                    <option label="Finalizado" value="finished"></option>
                                </select>
                            )
                        }
                    };
                }

                if (col.field === "actionAcc" && this.showActionAcc != undefined && this.showActionAcc == 0 && this.userPermission && this.userPermission.canAvaliate) {
                    return {
                        ...col,
                        renderBodyCell: ({ row }) => {
                            return h(
                                "button",
                                {
                                    class:"avaliationBtn",
                                    style: "cursor: pointer; font-size:0.8rem",
                                    on: {
                                        click: () => this.efficFunc('action', row.contextId)
                                    },
                                    title:'Avaliar'

                                },
                                "Avaliar"
                            )
                        }
                    };
                }

                if (col.field === "actionDelete") {
                    return {
                        ...col,
                        renderBodyCell: ({ row }) => {
                            return h(
                                "span",
                                {
                                    style: "cursor: pointer",
                                    on: {
                                        click: () => this.askToDelete(row),
                                    },
                                    title:'Remover'
                                },
                                [
                                    h("svg", {
                                        attrs: {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            fill: "#FA394D",
                                            class: "bi bi-trash-fill",
                                            viewBox: "0 0 16 16",
                                        },
                                        domProps: {
                                            innerHTML: `
                                            <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5M8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5m3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0" />
                                        `,
                                        },
                                    }),
                                ]
                            );
                        },
                    };
                }
                return col;
            });
        },
    },
    methods: {
        askToDelete(row) {
            this.rowToDelete = {
                data: { ...row },
                type: this.type
            };
            this.$emit('toDeleteItem', this.rowToDelete)

            this.$bvModal.show('rtaDealDelete');
        },

        cellDataChange(row, column, cellValue) {
            const { data } = this;

            let currentCell = data.find(
                (x) => x.rowKey === row["rowKey"] && x.field === column.field,
            );

            if (currentCell) {
                currentCell.value = cellValue;
            } else {
                let newCell = {
                    rowKey: row["rowKey"],
                    field: column.field,
                    value: cellValue,
                };
                this.data.push(newCell);
            }
        },
    },

    mounted() {
        this.dataSaved = this.data;
    },
};
</script>

<style>
.ve-table{
    z-index: 0;
}

.deal-header-table {
    background: #EBEBEB !important;
    color: #000000 !important;
    font-size: 0.8rem !important;
    font-weight: 600 !important;
    padding: 0.1rem !important;
    height: max-content !important;
    vertical-align: middle !important;
    border: 1px solid #8B8B8B !important;
}

.deal-header-table span {
    display: inline-flex !important;
    align-items: center;
}

.deal-header-table span i:first-child {
    top: -3px !important;
}

.deal-header-table span i:last-child {
    top: 6.5px !important;
}

.deal-header-table-delete-class {
    background-color: #ffefef !important;
}

.avaliationBtn{
    border: none;
    border-radius: 0.2rem;
    padding: 0.3rem;
    color: #ffffff;
    font-weight: 500;
    background-color: #008787;
}

.ve-table-body-td[col-key="whenInitPrev"],
.ve-table-body-td[col-key="whenFinishPrev"],
.ve-table-body-td[col-key="whenInitReal"],
.ve-table-body-td[col-key="whenFinishReal"]{
    width: 6rem !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
}

.ve-table-body-td[col-key="who"],
.ve-table-body-td[col-key="actionType"],
.ve-table-body-td[col-key="actionStatus"]{
    width: 4rem !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
}

.ve-table-body-td[col-key="actionDelete"]{
    width: 3rem !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
}

</style>